import noop from 'lodash-es/noop'
import { SIDEBAR_VIEWS } from '../../lib/constants'

export function* gotoSidebarWithHistory({ payload }, { put, select }) {
	const currentView = yield select((model) => model.app.sidebarView)

	if (typeof payload === 'string') {
		payload = {
			view: payload,
		}
	}

	let currentViewObject = {
		...currentView,
	}
	let selectedItemUuid = null

	switch (currentViewObject.view) {
		case SIDEBAR_VIEWS.FeatureDetail:
			selectedItemUuid = yield select((model) => model.features.selectedFeature.uuid)
			currentViewObject.metadata = {
				uuid: selectedItemUuid,
			}
			break
		case SIDEBAR_VIEWS.Collection:
			selectedItemUuid = yield select((model) => model.collections.selectedCollection.uuid)
			currentViewObject.metadata = {
				uuid: selectedItemUuid,
			}
			break
		default:
			break
	}

	yield put({ type: 'setShowSidebar', payload: true })

	if (currentView.view != payload.view) {
		if (!currentView.metadata || currentView.metadata != payload.metadata) {
			yield put({ type: 'pushSidebarHistory', payload: currentViewObject })
			yield put({ type: 'gotoSidebar', payload: payload })
		}
	}
}

export function* navSidebarBack({ callback = noop }, { put, select }) {
	const { sidebarHistoryStack } = yield select((model) => model.app)
	yield put({ type: 'popSidebarHistory' })
	yield put({ type: 'gotoSidebar', payload: sidebarHistoryStack[0] })
	callback(null)
}
